/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useContext, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useHistory, useParams } from 'react-router-dom';
import {
  TableBody,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@material-ui/core';
import { useRecoilState, useSetRecoilState } from 'recoil';
import LoadingOverlay from 'react-loading-overlay';
import AuthenticatedContext from '../../context/AuthenticatedContext';
import {
  backPageFlg,
  pageTitle,
  partsListPageInfo,
} from '../../context/PageRecoil';
import { pathnames } from '../../api';
import { requestDeviceDetail } from '../../api/device';
import useStyles, { blank, headerWidth } from '../../css/style';
import Paging from '../paging';
import { OneEquipment } from '../../models/data/Equipment';
import { requestOneEquipment } from '../../api/equipment';
import { routeName } from '../../App';
import { DeviceDetail } from '../../models/data/Device';
import DataDisp from './datadisp';
import DeviceItem from '../../models/data/DeviceItem';
import requestDeviceItemList, {
  requestCountDeviceItem,
} from '../../api/deviceItem';
import useErrorHandling from '../errorCheck';

type UserPageParams = {
  eqid: string;
  id: string;
};

/**
 * 機器部品一覧画面
 */
const DeviceitemList: React.FunctionComponent = () => {
  const history = useHistory();
  const [pageInfo] = useRecoilState(partsListPageInfo);
  const authContext = useContext(AuthenticatedContext); // ログインユーザの情報を取得
  const classes = useStyles();
  const [loading, setLoading] = useState(true); // ロード画面の状態管理
  const { eqid, id } = useParams<UserPageParams>();
  const [backFlg, setBackFlg] = useRecoilState(backPageFlg);
  const [data, setData] = useState<DeviceItem[]>([]); // 表示するメインデータ
  const [subdata, setSubData] = useState<OneEquipment>();
  const [subdata2, setSubData2] = useState<DeviceDetail>();
  const containerRef = React.useRef<HTMLDivElement>(null);
  const [scroll, setScroll] = useState<number>(0); // テーブルのスクロール位置
  const [scrollHorizon, setScrollHorizon] = useState<number>(0); // テーブルのスクロール位置
  const { errorCheck } = useErrorHandling(); // エラー処理
  const [nowYear, setNowYear] = useState<number | null>(null);

  const setPageTitle = useSetRecoilState(pageTitle);
  React.useEffect(() => {
    return setPageTitle({ pageTitle: '機器点検項目一覧' }); // ページのタイトルを設定
  }, [setPageTitle]);

  // APIのURL
  const urlDeviceItemList = history.createHref({
    pathname: pathnames.deviceItemList,
  }); // 機器点検項目一覧取得URL
  const urlCountDeviceItem = history.createHref({
    pathname: pathnames.deviceItemCount,
  }); // 機器点検項目一覧件数取得URL
  const urlOneEquipment = history.createHref({
    pathname: pathnames.oneEquipment,
  }); // 設備情報取得URL
  const urlDeviceDetail = history.createHref({
    pathname: pathnames.deviceDetail,
  }); // 機器情報取得URL

  // ページング用の変数
  const [totalData, setTotalData] = useState<number>(0); // データ数
  const [currentPage, setCurrentPage] = useState<number>(1); // 現在のページ
  const perPage = 20; // 一覧一ページあたりの表示件数

  // ソート用の変数
  type SortConfigType = { key: string; direction: string };
  const [sortConfig, setSortConfig] = React.useState<SortConfigType>({
    key: '',
    direction: '',
  });

  const headerCellProps = [
    {
      width: headerWidth.inspectItem,
      sortKey: 'inspectItem',
      text: '点検項目',
      className: `${classes.header} ${classes.stickyHeaderFirst}`,
    },
    {
      width: headerWidth.inspectItemSub,
      sortKey: 'inspectItemSub',
      text: '点検項目(小分類)',
      className: `${classes.header} ${classes.stickyHeaderOther}`,
    },
    {
      width: headerWidth.inspectDetails,
      sortKey: 'inspectDetails',
      text: '点検内容',
      className: `${classes.header} ${classes.stickyHeaderOther}`,
    },
    {
      width: headerWidth.criterion,
      sortKey: 'criterion',
      text: '判定基準',
      className: `${classes.header} ${classes.stickyHeaderOther}`,
    },
    {
      width: headerWidth.inspectYear,
      sortKey: 'inspectYear',
      text: '周期(年)',
      className: `${classes.header} ${classes.stickyHeaderOther}`,
    },
    {
      width: headerWidth.inspectWorkType,
      sortKey: 'inspectWorkType',
      text: '点検種別',
      className: `${classes.header} ${classes.stickyHeaderOther}`,
    },
    {
      width: headerWidth.s1,
      sortKey: `${nowYear != null ? `s${nowYear - 4}` : ''}`,
      text: `${nowYear != null ? nowYear - 4 : ''}`,
      className: `${classes.header} ${classes.stickyHeaderOther}`,
    },
    {
      width: headerWidth.s2,
      sortKey: `${nowYear != null ? `s${nowYear - 3}` : ''}`,
      text: `${nowYear != null ? nowYear - 3 : ''}`,
      className: `${classes.header} ${classes.stickyHeaderOther}`,
    },
    {
      width: headerWidth.s3,
      sortKey: `${nowYear != null ? `s${nowYear - 2}` : ''}`,
      text: `${nowYear != null ? nowYear - 2 : ''}`,
      className: `${classes.header} ${classes.stickyHeaderOther}`,
    },
    {
      width: headerWidth.s4,
      sortKey: `${nowYear != null ? `s${nowYear - 1}` : ''}`,
      text: `${nowYear != null ? nowYear - 1 : ''}`,
      className: `${classes.header} ${classes.stickyHeaderOther}`,
    },
    {
      width: headerWidth.s5,
      sortKey: `${nowYear != null ? `s${nowYear}` : ''}`,
      text: `${nowYear != null ? nowYear : ''}`,
      className: `${classes.header} ${classes.stickyHeaderOther}`,
    },
  ];

  // 画面遷移で送られた情報を設定する
  const locationSet = () => {
    // 初期値のままの場合
    if (currentPage === 0) {
      setCurrentPage(1);
    }
    // 戻るでの状態再現のフラグがTrueの場合
    if (backFlg.partsList) {
      setSortConfig({
        key: pageInfo.sortKey,
        direction: pageInfo.sortDirection,
      });
      setCurrentPage(pageInfo.page);
      // 一覧のテーブルがあるか確認
      if (containerRef.current) {
        setScroll(pageInfo.scrollPosition);
        setScrollHorizon(pageInfo.scrollPositionHorizon);
      }
      setBackFlg({ ...backFlg, partsList: false });
    }
  };

  // 一覧のページ変更処理
  const pageChange = (num: number) => {
    setScroll(0);
    setCurrentPage((prevPage) => {
      let newPage = prevPage + num;
      const tempTotalPages = Math.ceil(totalData / perPage);
      const totalPages = tempTotalPages > 0 ? tempTotalPages : 1;

      if (newPage < 1) newPage = 1;
      if (newPage > totalPages) newPage = totalPages;

      return newPage;
    });
  };

  // ソート機能の関数
  const sortStart = (key: string) => {
    pageChange(1 - currentPage); // はじめのページに戻る
    setScroll(0); // 表のスクロールバーをリセット
    let direction = 'asc';
    if (
      sortConfig &&
      sortConfig.key === key &&
      sortConfig.direction === 'asc'
    ) {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  // 初回画面表示時の処理
  useEffect(() => {
    setLoading(true); // 非同期処理前にsetLoading(true)
    locationSet();
    Promise.all([
      requestOneEquipment(urlOneEquipment, {
        equipmentId: Number(eqid),
      }),
      requestDeviceDetail(urlDeviceDetail, {
        custEqId: Number(eqid),
        mstId: Number(id),
      }),
    ])
      .then((responses) => {
        setSubData(responses[0].data); // 設備情報
        setSubData2(responses[1].data); // 機器情報
      })
      .catch((error) => {
        errorCheck(error); // エラー内容を確認
      })
      .finally(() => {
        setLoading(false); // 非同期処理後にsetLoading(false)
      });
  }, []);

  // データ更新時の処理
  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = scroll;
      // 戻るのときのみ処理をする
      if (scrollHorizon !== 0) {
        containerRef.current.scrollLeft = scrollHorizon;
        setScrollHorizon(0);
      }
    }
  }, [data]);

  // 部品情報の取得
  useEffect(() => {
    setLoading(true); // 非同期処理前にsetLoading(true)
    Promise.all([
      requestCountDeviceItem(urlCountDeviceItem, {
        custEqId: Number(eqid),
        mstId: Number(id),
      }),
      requestDeviceItemList(urlDeviceItemList, {
        custEqId: Number(eqid),
        mstId: Number(id),
        number: perPage,
        page: currentPage,
        sortKey: sortConfig.key,
        sortDirection: sortConfig.direction,
      }),
    ])
      .then((responses) => {
        setTotalData(responses[0].data?.dataNum ?? 0); // 件数
        setNowYear(responses[0].data?.year ?? null); // 現在年
        setData(responses[1].data); // 設備情報
      })
      .catch((error) => {
        errorCheck(error); // エラー内容を確認
      })
      .finally(() => {
        setLoading(false); // 非同期処理後にsetLoading(false)
      });
  }, [currentPage, sortConfig]);

  return (
    <LoadingOverlay
      active={loading}
      className={classes.load}
      spinner
      text="データを読み込んでいます..."
    >
      <div className={classes.root}>
        <Button
          variant="primary"
          className="my-2"
          onClick={() => {
            history.push(`${routeName.deviceMaintMenu}/${eqid}/${id}`);
          }}
        >
          戻る
        </Button>
        <br />
        <DataDisp userdata={authContext} data={subdata} data2={subdata2} />
        <div className={`${classes.paging} ${classes.deviceItemListWidth}`}>
          <Paging
            totalData={totalData}
            currentPage={currentPage}
            perPage={perPage}
            onPageChange={pageChange}
          />
        </div>
        <TableContainer
          component={Paper}
          className={`${classes.tableContainer} ${classes.deviceItemListHeight} ${classes.deviceItemListWidth}`}
          ref={containerRef}
        >
          <Table stickyHeader className={classes.tableDeviceItem}>
            <TableHead>
              <TableRow>
                {/* ヘッダのセルを生成 */}
                {headerCellProps.map(({ width, sortKey, text, className }) => (
                  <TableCell width={width} className={className}>
                    <Button
                      variant="link"
                      onClick={() => sortStart(sortKey)}
                      className={classes.linkButton}
                    >
                      {text}
                      {sortConfig &&
                        sortConfig.key === sortKey &&
                        sortKey != null &&
                        sortKey !== '' &&
                        (sortConfig.direction === 'asc' ? '▲' : '▼')}
                    </Button>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((d, index) => (
                <TableRow
                  className={index % 2 === 0 ? classes.evenRow : classes.oddRow}
                >
                  <TableCell
                    className={`${classes.cellFix} ${classes.stickyColumnFirst} ${classes.stringRow}`}
                  >
                    {d.inspectItem || blank}
                  </TableCell>
                  <TableCell
                    className={`${classes.cell} ${classes.stickyColumnOther} ${classes.stringRow}`}
                  >
                    {d.inspectItemSub}
                  </TableCell>
                  <TableCell
                    className={`${classes.cell} ${classes.stickyColumnOther} ${classes.stringRow}`}
                  >
                    {d.inspectDetails}
                  </TableCell>
                  <TableCell
                    className={`${classes.cell} ${classes.stickyColumnOther} ${classes.stringRow}`}
                  >
                    {d.criterion}
                  </TableCell>
                  <TableCell
                    className={`${classes.cell} ${classes.stickyColumnOther} ${classes.stringRow}`}
                  >
                    {d.inspectYear != null ? `${d.inspectYear}年` : ''}
                  </TableCell>
                  <TableCell
                    className={`${classes.cell} ${classes.stickyColumnOther} ${classes.stringRow}`}
                  >
                    {d.inspectWorkType}
                  </TableCell>
                  <TableCell
                    className={`${classes.cell} ${classes.stickyColumnOther} ${classes.stringRow}`}
                  >
                    {nowYear != null ? d[`s${nowYear - 4}`] ?? '' : ''}
                  </TableCell>
                  <TableCell
                    className={`${classes.cell} ${classes.stickyColumnOther} ${classes.stringRow}`}
                  >
                    {nowYear != null ? d[`s${nowYear - 3}`] ?? '' : ''}
                  </TableCell>
                  <TableCell
                    className={`${classes.cell} ${classes.stickyColumnOther} ${classes.stringRow}`}
                  >
                    {nowYear != null ? d[`s${nowYear - 2}`] ?? '' : ''}
                  </TableCell>
                  <TableCell
                    className={`${classes.cell} ${classes.stickyColumnOther} ${classes.stringRow}`}
                  >
                    {nowYear != null ? d[`s${nowYear - 1}`] ?? '' : ''}
                  </TableCell>
                  <TableCell
                    className={`${classes.cell} ${classes.stickyColumnOther} ${classes.stringRow}`}
                  >
                    {nowYear != null ? d[`s${nowYear}`] ?? '' : ''}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </LoadingOverlay>
  );
};

export default DeviceitemList;
